import React, { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { AuthService } from "../../../../services/api/Auth/AuthService";
import './login.css'
import { useForm } from 'react-hook-form'
import { AuthContext } from "../../../../Contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Login = () => {
    const HASH_COOKIE = process.env.REACT_APP_COOKIE_HASH;
   
    const { setAuth,  setUser } = useContext(AuthContext)


    const { register, handleSubmit, formState: { errors } } = useForm()

    const [msgError, setMsgError] = useState('')
    const navigate = useNavigate()
    const [cookies, setCookie, removeCookie] = useCookies([HASH_COOKIE], { doNotParse: true });
    const [disableSalvar, setDisableSalvar] = useState(false)
    

    const onSubmit = async (data) => {
        //console.log(data)
        // const res = await AuthService.authorize('teste@teste.com', '123456')
        setDisableSalvar(true)
        const res = await AuthService.authorize(data.email, data.senha)
        console.log(res);
        if (res == undefined) {
            setDisableSalvar(false)
            setMsgError("Usuário e/ou senha inválidos")
            return false;
        }
        if (res.data.status == 'success') {

            setUser(res.data.user)
            setAuth(true);
            localStorage.setItem('tk_hsp', res.data.authorization.token)
            localStorage.setItem('us_hsp', JSON.stringify(res.data.user))

            let dataExp = new Date().getTime();
            dataExp = dataExp + 3600000
            dataExp = new Date(dataExp)
            console.log(dataExp)
            setCookie(HASH_COOKIE, res.data, { expires: dataExp })

            navigate('/admin/inicio')
        }
    }



    return (
        <>

            <div id="container-login" className="">


                <div id="container-content">
                    <h4 className="text-center text-primary">Login</h4>

                    <Form.Group controlId="formEmail">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control type="text"
                            {...register("email", { required: true })}
                        ></Form.Control>
                        {errors?.email?.type == 'required' && <p className="text-danger">E-mail obrigatório</p>}
                    </Form.Group>

                    <Form.Group controlId="formSenha" className="mt-15">
                        <Form.Label>Senha</Form.Label>
                        <Form.Control type="password"
                            {...register("senha", { required: true, minLength: 5 })}></Form.Control>
                        {errors?.senha?.type == 'required' && <p className="text-danger">Senha obrigatória</p>}
                        {errors?.senha?.type == 'minLength' && <p className="text-danger">A senha deve ter no mínimo 7 caracteres</p>}
                    </Form.Group>

                    {(msgError != '') ? <div class="alert alert-danger">
                        {msgError}</div>
                        : ''}
    <br></br>
                    <div className="text-center ">
                        <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                            {(disableSalvar) ? <>
                                <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Aguarde...
                            </> : 'Entrar'}</Button>        </div>

                </div>


            </div>




        </>
    )

}
export default Login;